import { BaseGenerator } from '../core/BaseGenerator.js';

/**
 * Saudi Arabian National ID generator following Single Responsibility Principle
 */
export class SaGenerator extends BaseGenerator {
  generate() {
    // First digit must be 1 or 2
    const firstDigit = this.randomInt(1, 2);
    
    // Generate remaining 8 digits
    const remainingDigits = this.randomDigits(8);
    
    // Calculate Luhn check digit
    const digits = firstDigit + remainingDigits;
    let sum = 0;
    let alternate = false;

    for (let i = digits.length - 1; i >= 0; i--) {
      let n = parseInt(digits[i]);
      
      if (alternate) {
        n *= 2;
        if (n > 9) {
          n = (n % 10) + 1;
        }
      }
      
      sum += n;
      alternate = !alternate;
    }

    const checkDigit = (10 - (sum % 10)) % 10;
    return digits + checkDigit;
  }
}